import { gql } from 'graphql-request';

const subscribeToNewsletter = gql`
  mutation subscribeToNewsletter($email: String!, $hostname: String!) {
    subscribeToNewsletter(input: { email: $email, hostname: $hostname }) {
      errors {
        field
        messages
      }
    }
  }
`;

export default subscribeToNewsletter;
